import { canUseBitmap } from "@zyzgroup/core-common";
import { getDOMMatrix } from "../math/";

export const bitmapMapper = {
  map: new Map<ImageBitmap, OffscreenCanvas>(),

  // see https://github.com/catdad/canvas-confetti/issues/209
  // creating canvases is actually pretty expensive, so we should create a
  // 1:1 map for bitmap:canvas, so that we can animate in
  // a performant manner, but also not store them forever so that we don't
  // have a memory leak
  transform: function (bitmap: ImageBitmap): ImageBitmap | OffscreenCanvas {
    if (canUseBitmap) {
      return bitmap;
    }
    if (this.map.has(bitmap)) {
      return this.map.get(bitmap)!;
    }
    const canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
    const ctx = canvas.getContext("2d");
    ctx?.drawImage(bitmap, 0, 0);
    this.map.set(bitmap, canvas);
    return canvas;
  },

  clear: function () {
    this.map.clear();
  }
};

export function getBitmapFromCanvas(
  width: number,
  height: number,
  cb: (ctx: OffscreenCanvasRenderingContext2D) => void
): ImageBitmap | undefined {
  const canvas = new OffscreenCanvas(width, height);
  const ctx = canvas.getContext("2d");
  if (ctx) {
    cb(ctx);
    return canvas.transferToImageBitmap();
  }
}

export function drawBitmapInCanvas(
  ctx: OffscreenCanvasRenderingContext2D | CanvasRenderingContext2D,
  bitmap: ImageBitmap,
  options?: {
    x?: number;
    y?: number;
    degree?: number;
    scaleX?: number;
    scaleY?: number;
    originMatrix?: string | number[];
  }
) {
  const pattern = ctx.createPattern(
    bitmapMapper.transform(bitmap),
    "no-repeat"
  );
  if (pattern) {
    const matrix = getDOMMatrix(options);
    pattern.setTransform(matrix);
    ctx.fillStyle = pattern;
  }
  // ctx.globalAlpha = 1 - progress;
  // const width = bitmap.width;
  // const height = bitmap.height;
  // const tx = transformOptions?.tx || 0;
  // const ty = transformOptions?.ty || 0;
  // ctx.fillRect(tx - width / 2, ty - height / 2, width, height);
  // ctx.globalAlpha = 1;
}
